import React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/utils/cn';

const alertVariants = cva('rounded-control border px-3 py-2 text-xs', {
  variants: {
    tone: {
      info: 'border-accent/30 bg-accent-soft text-accent-text',
      success: 'border-success/30 bg-success/10 text-success-text',
      warning: 'border-warning/40 bg-warning/10 text-warning-text',
      danger: 'border-danger/40 bg-danger/10 text-danger-text',
    },
  },
  defaultVariants: { tone: 'info' },
});

export interface AlertProps extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof alertVariants> {}

/** Inline message banner. Warning and danger are announced to screen readers (role="alert"). */
export const Alert: React.FC<AlertProps> = ({ tone, className, role, ...props }) => (
  <div
    role={role ?? (tone === 'danger' || tone === 'warning' ? 'alert' : 'status')}
    className={cn(alertVariants({ tone }), className)}
    {...props}
  />
);

export default Alert;
